import { render, staticRenderFns } from "./ProfileView.vue?vue&type=template&id=24eafed2&scoped=true&"
import script from "./ProfileView.vue?vue&type=script&lang=ts&"
export * from "./ProfileView.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileView.vue?vue&type=style&index=0&id=24eafed2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24eafed2",
  null
  
)

export default component.exports